<template>
  <div class="container">
    <div class="common-table background-tasks">
      <div class="common-table__row common-table__header">
        <div
          v-for="(item, index) in columns"
          :key="index"
          class="common-table__header-cell"
        >
          {{ item.label }}
        </div>
      </div>
      <div
        v-for="(item, index) in backgroundTasks"
        :key="index"
        class="common-table__row"
      >
        <div
          v-for="(cell, cellIndex) in columns"
          :key="cellIndex"
          class="common-table__cell"
        >
          {{ item[cell.prop] }}
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'

const COLUMNS = [
  { label: 'ID', prop: 'id' },
  { label: 'Next Run Time', prop: 'next_run_time' },
  { label: 'Current Time', prop: 'current_time' },
  { label: 'Minutes Until Next Run', prop: 'seconds_until_run' }
]
export default {
  name: 'BackgroundTasks',
  data () {
    return {
      isDataFetched: false,
      isDataUpdating: true,
      columns: [...COLUMNS]
    }
  },
  async mounted () {
    try {
      await this.getBackgroundTasksData()
      this.isDataFetched = true
    } catch {} finally {
      this.isDataUpdating = false
    }
  },
  computed: {
    ...mapState('backgroundTasks', ['backgroundTasks'])
  },
  methods: {
    ...mapActions('backgroundTasks', ['getBackgroundTasksData'])
  }
}
</script>

<style lang="scss" scoped>
  .background-tasks {
    margin-top: 24px;
  }

  .common-table {
    border-radius: 4px;
    overflow: visible;

    &__header {
      border-top-right-radius: 4px;
      border-top-left-radius: 4px;
      background-color: rgba(1, 22, 39, 0.1) !important;
    }
    &__header-cell {
      color: $rfx-dark-march;
      font-weight: bold;
      padding: 0 20px;
      height: 60px;
      display: flex;
      align-items: center;
      font-size: 14px;

      &:first-child {
        margin-left: 10px;
      }
    }
    &__cell {
      color: $rfx-dark-march;
    }
  }
</style>
